import React, { Fragment } from "react";
import { Button, Menu } from "@theorgchartdev/storybook";
import { BuildFieldDefOptions } from "../../../Blocks/Menus/FieldsMenu/CellFieldsMenu";
import {
  InsertRow,
  DisableAnyInsert,
  InsertCol,
  CheckBoxCellControlEnabled,
  InsertCellField,
  GetLayoutObjClass
} from "@/appComponents/Blocks/Composites/LayoutHoverToolbar/Utils";
import { appstr } from "@coreapp/utils/appstr";

const BLEInsertOptions = [
  {
    value: "rows",
    label: "Rows",
    lookup: true,
    disabled: DisableAnyInsert,
    options: [
      {
        value: "insertrowabove",
        clickHandler: InsertRow
      },
      {
        value: "insertrowbelow",
        clickHandler: () => InsertRow(false)
      }
    ]
  },
  {
    value: "columns",
    label: appstr("Columns"),
    disabled: DisableAnyInsert,
    lookup: true,
    options: [
      {
        value: "insertcolleft",
        clickHandler: InsertCol
      },
      {
        value: "insertcolright",
        clickHandler: () => InsertCol(false)
      }
    ],
    divider: true
  },
  {
    value: "field",
    label: "Field",
    options: () => {
      const objClass = GetLayoutObjClass();

      return BuildFieldDefOptions(
        InsertCellField,
        "mtb-ble-insert-field",
        [],
        {
          calcs: true,
          internal: true,
          photos: true,
          locked: false,
          none: true,
          freetext: true
        },
        objClass
      );
    },
    subListConfig: {
      searchProps: {
        placeholder: appstr("Search"),
        dataTestId: "mtb-ble-insert-field--search"
      }
    },
    listProps: { enableVirtualization: false },
    disabled: DisableAnyInsert
  }
];

const BuildInsertOptions = () => {
  let options = [];
  for (let insertOpt of BLEInsertOptions) {
    let opt = {};
    opt.value = insertOpt.value;
    opt.dataTestId = `mtb-layout-editor-insert-menu-${insertOpt.value}`;
    opt.label = appstr(insertOpt.label);
    opt.icon = insertOpt.icon;
    if (insertOpt.options) {
      opt.options =
        typeof insertOpt.options === "function" ? insertOpt.options() : insertOpt.options;
      if (insertOpt.lookup) {
        opt.options.forEach(item => {
          item.dataTestId = `mtb-layout-editor-insert-menu-${insertOpt.value}-${item.value}`;
          item.disabled = !CheckBoxCellControlEnabled(item.value);
          item.label = appstr(item.value);
        });
      }
      opt.listProps = {
        ...insertOpt.listProps,
        "data-testid": `mtb-layout-editor-insert-menu-${insertOpt.value}-popover`
      };
    }
    opt.divider = insertOpt.divider;
    if (insertOpt.subListConfig) opt.subListConfig = insertOpt.subListConfig;
    if (insertOpt.clickHandler) opt.clickHandler = insertOpt.clickHandler;
    if (typeof insertOpt.disabled === "function") opt.disabled = insertOpt.disabled();
    else opt.disabled = !CheckBoxCellControlEnabled(insertOpt.value);
    options.push(opt);
  }
  return options;
};

export const BoxLayoutEditorInsertMenu = () => {
  return (
    <Fragment>
      <Menu
        dataTestId="mtb-layout-editor-insert-menu"
        trigger={
          <Button modifier="ghost" size="medium" type="button">
            {appstr("Insert")}
          </Button>
        }
        options={BuildInsertOptions()}
        listWidth={"medium"}
      />
    </Fragment>
  );
};
